(function () {
  'use strict';

  var CFG = window.CD_SP_CONFIG || {};
  var SP_VARIANT = String(CFG.variantId || '');
  var SP_PRICE = Number(CFG.price || 0);
  var SP_TITLE = CFG.title || 'Shipping Protection';
  var TIERS = Array.isArray(CFG.tiers) ? CFG.tiers : [{ qty: 2, pct: 10 }, { qty: 3, pct: 15 }, { qty: 4, pct: 20 }];
  var OFF_KEY = 'cd_sp_disabled';

  var HAS_SP = !!SP_VARIANT && SP_VARIANT !== '0';

  var busy = false;
  var currency = 'EUR';
  var drawerEl = document.querySelector('[data-cart-drawer]');
  if (drawerEl && drawerEl.dataset.cartCurrency) currency = drawerEl.dataset.cartCurrency;

  function money(cents) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency', currency: currency
      }).format(cents / 100);
    } catch (e) { return (cents / 100).toFixed(2); }
  }

  function isOff() { try { return sessionStorage.getItem(OFF_KEY) === '1'; } catch (e) { return false; } }
  function setOff(v) { try { v ? sessionStorage.setItem(OFF_KEY, '1') : sessionStorage.removeItem(OFF_KEY); } catch (e) {} }

  function getCart() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
  }

  function addSP() {
    busy = true;
    return fetch('/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(SP_VARIANT), quantity: 1 }] })
    }).finally(function () { busy = false; });
  }

  function removeSP(key) {
    busy = true;
    var updates = {}; updates[key] = 0;
    return fetch('/cart/update.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates })
    }).finally(function () { busy = false; });
  }

  function findSP(cart) {
    if (!HAS_SP) return null;
    for (var i = 0; i < cart.items.length; i++) {
      if (String(cart.items[i].variant_id) === SP_VARIANT) return cart.items[i];
    }
    return null;
  }

  function realCount(cart) {
    var n = 0;
    cart.items.forEach(function (it) { if (String(it.variant_id) !== SP_VARIANT) n += it.quantity; });
    return n;
  }

  function reconcile() {
    if (busy) return Promise.resolve();
    return getCart().then(function (cart) {
      if (!HAS_SP) { paint(cart); return; }
      var sp = findSP(cart);
      var others = realCount(cart);

      if (others === 0) {
        setOff(false);
        if (sp) return removeSP(sp.key).then(refresh);
        paint(cart); return;
      }
      if (isOff() && sp) return removeSP(sp.key).then(refresh);
      if (!isOff() && !sp) return addSP().then(refresh);
      if (sp && sp.quantity > 1) return removeSP(sp.key).then(addSP).then(refresh);
      paint(cart);
    });
  }

  function refresh() {
    return getCart().then(function (cart) {
      paint(cart);
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
    });
  }

  function compareMap() {
    var el = document.querySelector('[data-cart-drawer-compare-at-prices]');
    if (!el) return {};
    try { return JSON.parse(el.textContent) || {}; } catch (e) { return {}; }
  }

  function paint(cart) {
    var sp = findSP(cart);
    var count = realCount(cart);
    var comps = compareMap();

    var tierPct = 0;
    TIERS.forEach(function (t) { if (count >= t.qty) tierPct = t.pct; });

    document.querySelectorAll('[data-cart-item-key]').forEach(function (li) {
      var titleEl = li.querySelector('.cart-drawer__item-title');
      var title = titleEl ? titleEl.textContent.trim() : '';
      var hide = (sp && li.dataset.cartItemKey === sp.key) || title === SP_TITLE;
      li.classList.toggle('cd-hidden-line', !!hide);
    });

    cart.items.forEach(function (it) {
      if (String(it.variant_id) === SP_VARIANT) return;

      var li = document.querySelector('[data-cart-item-key="' + it.key + '"]');
      if (!li) return;
      var wrap = li.querySelector('.cart-drawer__item-prices');
      var priceEl = li.querySelector('.cart-drawer__item-price');
      if (!wrap || !priceEl) return;

      var compUnit = Number(comps[it.variant_id] || 0);
      var original = compUnit > it.final_price
        ? compUnit * it.quantity
        : it.final_line_price;

      var now = Math.round(it.final_line_price * (100 - tierPct) / 100);
      var saved = original - now;

      priceEl.textContent = money(now);

      var compEl = li.querySelector('.cart-drawer__item-compare-price');
      if (saved > 0) {
        if (!compEl) {
          compEl = document.createElement('p');
          compEl.className = 'cart-drawer__item-compare-price';
          wrap.insertBefore(compEl, wrap.firstChild);
        }
        compEl.textContent = money(original);
        compEl.hidden = false;
      } else if (compEl) {
        compEl.hidden = true;
      }

      // Groen label: alleen de stapelkorting (tier), niet de compare-at sale
      var tierSaved = it.final_line_price - now;
      var save = wrap.querySelector('.cd-save');
      if (tierSaved > 0) {
        if (!save) {
          save = document.createElement('span');
          save.className = 'cd-save';
          wrap.appendChild(save);
        }
        save.textContent = '(Save ' + money(tierSaved) + ')';
      } else if (save) {
        save.remove();
      }
    });

    document.querySelectorAll('[data-cart-drawer-count]').forEach(function (el) { el.textContent = count; });

    var toggle = document.querySelector('[data-cd-sp-toggle]');
    if (toggle) {
      var on = !!sp;
      toggle.setAttribute('aria-checked', on ? 'true' : 'false');
      toggle.classList.toggle('is-on', on);
    }

    var spLine = document.querySelector('[data-cd-sp-line]');
    if (spLine) spLine.textContent = money(sp ? sp.final_line_price : SP_PRICE);

    var total = document.querySelector('[data-cd-checkout-total]');
    if (total) total.textContent = money(cart.total_price);

    var drawer = document.querySelector('[data-cart-drawer]');
    if (drawer) {
      drawer.classList.toggle('cd-empty', count === 0);
      var footer = drawer.querySelector('[data-cart-drawer-footer]');
      if (footer) footer.hidden = count === 0;
    }

    paintTier(count);
  }

  function paintTier(count) {
    var bar = document.querySelector('[data-cd-tier]');
    if (!bar) return;
    if (!TIERS.length) { bar.hidden = true; return; }

    var reached = null, next = null;
    TIERS.forEach(function (t) {
      if (count >= t.qty) reached = t;
      else if (!next) next = t;
    });

    var msg = bar.querySelector('[data-cd-tier-msg]');
    var fill = bar.querySelector('[data-cd-tier-fill]');
    var nodes = bar.querySelectorAll('[data-cd-tier-step]');

    var stops = [37.5, 62.5, 87.5];
    var pct = 0;
    for (var i = 0; i < TIERS.length; i++) {
      if (count >= TIERS[i].qty) pct = stops[i];
    }
    if (pct === 0) {
      pct = Math.min(1, count / TIERS[0].qty) * stops[0];
    }
    if (fill) fill.style.width = Math.min(100, pct) + '%';

    nodes.forEach(function (el) {
      el.classList.toggle('is-reached', count >= Number(el.dataset.cdTierStep));
    });

    if (msg) {
      if (!next && reached) {
        msg.innerHTML = 'You unlocked <strong>' + reached.pct + '% extra</strong> off!';
      } else if (next) {
        var need = next.qty - count;
        msg.innerHTML = 'Add ' + need + ' more item' + (need === 1 ? '' : 's') +
                        ' to save an extra <strong>' + next.pct + '%</strong>!';
      }
    }

    bar.hidden = count === 0;
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-cd-sp-toggle]');
    if (!t) return;
    e.preventDefault();
    if (busy) return;
    var turningOff = t.classList.contains('is-on');
    setOff(turningOff);
    t.classList.toggle('is-on', !turningOff);
    reconcile();
  });

  var origFetch = window.fetch;
  window.fetch = function () {
    var url = arguments[0];
    if (url && url.url) url = url.url;
    var isCartWrite = typeof url === 'string' && /\/cart\/(add|change|update|clear)/.test(url);
    var p = origFetch.apply(this, arguments);
    if (isCartWrite && !busy) p.then(function () { setTimeout(reconcile, 60); }).catch(function () {});
    return p;
  };

  var origSend = XMLHttpRequest.prototype.send;
  var origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (m, u) { this.__cdUrl = u; return origOpen.apply(this, arguments); };
  XMLHttpRequest.prototype.send = function () {
    var self = this;
    if (typeof self.__cdUrl === 'string' && /\/cart\/(add|change|update|clear)/.test(self.__cdUrl)) {
      self.addEventListener('load', function () { if (!busy) setTimeout(reconcile, 60); });
    }
    return origSend.apply(this, arguments);
  };

  var body = document.querySelector('[data-cart-drawer-body]');
  if (body) {
    var pending = null;
    new MutationObserver(function () {
      clearTimeout(pending);
      pending = setTimeout(function () { getCart().then(paint); }, 40);
    }).observe(body, { childList: true, subtree: true });
  }

  document.addEventListener('DOMContentLoaded', reconcile);
  if (document.readyState !== 'loading') reconcile();
})();